import type { MediaAsset } from "../../../../hooks/mediaLibraryData"
import type { Tag } from "../../../../hooks/tagData"

export function getCommonMediaTags(medias: MediaAsset[]): Tag[] {
  const totalMedias = medias.length
  const tagCountMap: Record<Tag["id"], number> = {}
  const allTags: Tag[] = []

  // Count the occurrences of each tag and store tag references
  medias.forEach((media) => {
    media.tags.forEach((tag) => {
      if (!tagCountMap[tag.id]) {
        tagCountMap[tag.id] = 0
        allTags.push(tag)
      }
      tagCountMap[tag.id]++
    })
  })

  // Filter tags that are common across all media
  const commonTags = allTags.filter(
    (tag) => tagCountMap[tag.id] === totalMedias,
  )

  return commonTags
}
